export const CPS_ACTIONS_ALLOWED_FOR_DOCUMENT = {
  NONE: 0,
  DOWNLOAD: 1,
  LOCK: 1 << 1,
  UPDATE: 1 << 2,
  DELETE: 1 << 3
};

export type CpsUserAllowedActions =
  (typeof CPS_ACTIONS_ALLOWED_FOR_DOCUMENT)[keyof typeof CPS_ACTIONS_ALLOWED_FOR_DOCUMENT];
